import React, { useState } from "react";
import { Colors } from "../Constants/colors";
import placeHolderImage from "./../images/user-image-placeholder.png";
import { useUserStore } from "../hooks/userHooks/user.hooks";
import { logout } from "../Services/users/users.service";
import { useDispatch } from "react-redux";
import { setShowSideMenuBar } from "../Redux/Slices/sideMenu.slice";
import notificationIcon from "./../images/notification-icon.svg";
import { useMobile } from "../hooks/deviceHooks/useDevice.hooks";
import { IconWithBadge } from "./IconWithBadge";
import { NotificationModal } from "./NotificationComponent/NotificationModal";
import queryClient from "../config/queryClient";
import { Notifications_key } from "../hooks/notifications/notifications.hooks";
import { useSocketListener } from "../hooks/socketHooks/socket.hooks";
import { SocketEventEnum } from "../Constants/Enums/Socket.enum";
import { getValue } from "../utils/object.utils";
import {
  useGetUnseenNotificationsCount,
  useMarkNoticationAsRead,
} from "../hooks/notificationHooks/notifications.hooks";
import { setErrorMessage } from "../Redux/Slices/alert.slice";
import { parseApiError } from "../Helper/apiError.helper";
import {
  DISPLAY,
  FLEX_DIRECTION,
  ALIGN_ITEMS,
  JUSTIFY_CONTENT,
  SPACING,
  FONT_SIZE,
} from "../Constants/Enums/styles.enum";
import { FontFamily } from "../Constants/Enums/FontFamily.enums";
import { LogoutIcon } from "./Icon/LogoutIcon";

export const Navbar = () => {
  const { user } = useUserStore();
  const isMobile = useMobile();
  const dispatch = useDispatch();

  const [openNotification, setOpenNotification] = useState(false);
  const [socketNotificationCount, setSocketNotificationCount] = useState(0);

  const { data: unSeenNotificationsCount } = useGetUnseenNotificationsCount();

  useSocketListener({
    eventName: SocketEventEnum.UNSEEN_NOTIFICATIONS_COUNT,
    handlerFunction: (countData) => {
      const count = getValue(countData, "unSeenNotificationsCount", 0);

      setSocketNotificationCount(count);
    },
  });

  const { mutate: markNotificationAsRead } = useMarkNoticationAsRead({
    onSuccess: () => {
      setSocketNotificationCount(0);
    },
    onError: (error) => {
      dispatch(setErrorMessage(parseApiError(error)));
    },
  });

  const handleMarkNotificationAsRead = () => {
    markNotificationAsRead();
  };

  const onLogout = () => {
    logout();
  };

  //TODO -> Make the logout button in dropdown.
  return (
    <div
      className="w-full flex flex-row justify-between items-center"
      style={{
        height: "72px",
        backgroundColor: Colors.White,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        padding: `${SPACING.S16} ${SPACING.S24}`,
        borderBottom: `1px solid ${Colors.LightGrey}`,
      }}
    >
      {isMobile ? (
        <div
          onClick={() => {
            dispatch(setShowSideMenuBar(true));
          }}
          style={{
            cursor: "pointer",
            padding: SPACING.S8,
            borderRadius: "8px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = Colors.VeryLightGrey;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="28"
            height="28"
            viewBox="0 0 50 50"
          >
            <path
              d="M 5 8 A 2.0002 2.0002 0 1 0 5 12 L 45 12 A 2.0002 2.0002 0 1 0 45 8 L 5 8 z M 5 23 A 2.0002 2.0002 0 1 0 5 27 L 45 27 A 2.0002 2.0002 0 1 0 45 23 L 5 23 z M 5 38 A 2.0002 2.0002 0 1 0 5 42 L 45 42 A 2.0002 2.0002 0 1 0 45 38 L 5 38 z"
              fill={Colors.CrimsonRed}
            ></path>
          </svg>
        </div>
      ) : (
        <></>
      )}

      <div
        style={{
          display: DISPLAY.FLEX,
          flexDirection: FLEX_DIRECTION.ROW,
          width: "100%",
          justifyContent: JUSTIFY_CONTENT.END,
          gap: SPACING.S16,
          alignItems: ALIGN_ITEMS.CENTER,
        }}
      >
        {/* Notification Section */}
        <div
          style={{
            position: "relative",
            padding: SPACING.S8,
            borderRadius: "10px",
            cursor: "pointer",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = Colors.VeryLightGrey;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        >
          <IconWithBadge
            img={notificationIcon}
            badgeValue={socketNotificationCount || unSeenNotificationsCount}
            onClick={() => {
              setOpenNotification(true);
              queryClient.invalidateQueries({
                queryKey: [Notifications_key.GET_NOTIFICATIONS],
              });
              handleMarkNotificationAsRead();
            }}
          />
          <div>
            <NotificationModal
              open={openNotification}
              onClose={() => [setOpenNotification(false)]}
              wrapperStyle={{
                position: "absolute",
                top: 35,
                left: -210,
              }}
            />
          </div>
        </div>

        {/* Vertical Divider */}
        <div
          style={{
            width: "1px",
            height: "40px",
            backgroundColor: Colors.LightGrey,
          }}
        />

        {/* User Info Section - Improved */}
        <div
          style={{
            display: DISPLAY.FLEX,
            flexDirection: FLEX_DIRECTION.ROW,
            alignItems: ALIGN_ITEMS.CENTER,
            gap: SPACING.S12,
            padding: `${SPACING.S6} ${SPACING.S8}`,
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              overflow: "hidden",
              border: `2px solid ${Colors.TangerineOrange}`,
              boxShadow: `0 2px 8px ${Colors.TangerineOrange}30`,
              display: DISPLAY.FLEX,
              alignItems: ALIGN_ITEMS.CENTER,
              justifyContent: JUSTIFY_CONTENT.CENTER,
              flexShrink: 0,
            }}
          >
            <img
              src={placeHolderImage}
              alt="User avatar"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>

          {!isMobile && (
            <div
              style={{
                display: DISPLAY.FLEX,
                flexDirection: FLEX_DIRECTION.COLUMN,
                justifyContent: JUSTIFY_CONTENT.CENTER,
                gap: "2px",
              }}
            >
              <div
                style={{
                  fontSize: FONT_SIZE.F14,
                  fontFamily: FontFamily.POPPINS_REGULAR,
                  color: Colors.Black,
                  fontWeight: "600",
                  lineHeight: "1.2",
                }}
              >
                {user?.first_name}
              </div>
              <div
                style={{
                  fontSize: FONT_SIZE.F12,
                  fontFamily: FontFamily.ROBOTO_REGULAR,
                  color: Colors.Grey,
                  textTransform: "capitalize",
                  lineHeight: "1.2",
                }}
              >
                {user?.role}
              </div>
            </div>
          )}
        </div>

        {/* Vertical Divider */}
        <div
          style={{
            width: "1px",
            height: "40px",
            backgroundColor: Colors.LightGrey,
          }}
        />

        <div
          style={{
            display: DISPLAY.FLEX,
            alignItems: ALIGN_ITEMS.CENTER,
            gap: SPACING.S8,
            padding: `${SPACING.S10} ${SPACING.S16}`,
            backgroundColor: Colors.White,
            border: `1.5px solid ${Colors.CrimsonRed}`,
            borderRadius: "10px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            color: Colors.CrimsonRed,
          }}
          onClick={onLogout}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = Colors.CrimsonRed;
            e.currentTarget.style.color = Colors.White;
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = `0 4px 12px ${Colors.CrimsonRed}40`;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = Colors.White;
            e.currentTarget.style.color = Colors.CrimsonRed;
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          <LogoutIcon />
          {!isMobile && (
            <span
              style={{
                fontSize: FONT_SIZE.F14,
                fontFamily: FontFamily.POPPINS_REGULAR,
                fontWeight: "500",
              }}
            >
              Logout
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
